import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

function Header({ logo }) {
	const barRef = useRef(null);
	const [barHeight, setBarHeight] = useState(0);

	useEffect(() => {
		const measure = () => {
			if (barRef.current) {
				setBarHeight(barRef.current.offsetHeight);
			}
		};
		measure();
		window.addEventListener("resize", measure);
		return () => window.removeEventListener("resize", measure);
	}, []);

	return (
		<>
			<div
				ref={barRef}
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					zIndex: 50,
				}}
			>
			<div
				className="util-bar"
				style={{
					background: "var(--primary-dark)",
					color: "#fff",
					display: "flex",
					justifyContent: "flex-end",
					alignItems: "center",
					gap: 28,
					padding: "9px 48px",
					fontFamily: "var(--body-font)",
					fontSize: 13,
				}}
			>
				<a
					href="tel:0893891733"
					style={{ display: "flex", alignItems: "center", gap: 8, color: "#fff", textDecoration: "none" }}
				>
					<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
					</svg>
					<span>(08) 9389 1733</span>
				</a>
				<a
					href="mailto:info@advancedgiwa.com.au"
					style={{ display: "flex", alignItems: "center", gap: 8, color: "#fff", textDecoration: "none" }}
				>
					<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
						<path d="M22 6 12 13 2 6" />
						<rect x="2" y="4" width="20" height="16" rx="2" />
					</svg>
					<span>info@advancedgiwa.com.au</span>
				</a>
			</div>

			<header
				className="site-header"
				style={{
					background: "var(--surface)",
					borderBottom: "1px solid var(--border)",
					padding: "14px 48px",
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					gap: 32,
				}}
			>
				<Link to="/" style={{ display: "block", width: 240, flexShrink: 0 }}>
					{logo}
				</Link>
				<nav className="main-nav" style={{ display: "flex", alignItems: "center", gap: 26, flexWrap: "wrap" }}>
					<Link to="/" className="nav-link">
						Home
					</Link>
					<Link to="/our-team" className="nav-link">
						Our Team
					</Link>
					<Link to="/services" className="nav-link">
						Services
					</Link>
					<Link to="/patient-information" className="nav-link">
						Patient Information
					</Link>
					<Link to="/articles" className="nav-link">
						Articles
					</Link>
					<Link to="/Newsletters" className="nav-link">
						Newsletters
					</Link>
					<Link to="/contact" className="nav-link">
						Contact
					</Link>
					<Link
						to="/contact"
						className="btn-warm"
						style={{
							fontFamily: "var(--body-font)",
							fontSize: 14,
							fontWeight: 600,
							padding: "10px 20px",
							borderRadius: 8,
							marginLeft: 6,
							textDecoration: "none",
							display: "inline-block",
						}}
					>
						Contact Us
					</Link>
				</nav>
			</header>
			</div>
			<div style={{ height: barHeight }} aria-hidden="true" />
		</>
	);
}

Header.propTypes = {
	logo: PropTypes.node.isRequired,
};

export default Header;
